var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "button-back touch",
    class: {
      'button-back--disable': _vm.isTopLevelNav
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18.2 273l-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232 424 232l24 0 0 48-24 0L93.1 280 205.8 392.6l17 17-33.9 33.9-17-17L18.2 273z"
    }
  })]), _c('div', [_vm._v(_vm._s(_vm.config.labels.backButton[_vm.language.code]))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }